import { Sparkles, ArrowRight } from "lucide-react";

export default function AnnouncementBar() {
  return (
    <div
      data-testid="announcement-bar"
      className="fixed top-0 inset-x-0 z-[60] h-9 bg-[#F97316] text-white text-xs sm:text-sm font-medium flex items-center justify-center px-4 shadow-[0_1px_0_rgba(0,0,0,0.05)]"
    >
      <a
        href="#contact"
        data-testid="announcement-cta"
        className="flex items-center gap-2 hover:opacity-90 transition-opacity"
      >
        <Sparkles className="h-3.5 w-3.5" />
        <span className="tracking-wide">
          <span className="font-bold uppercase tracking-widest">New Customer?</span>
          <span className="mx-2 opacity-70 hidden sm:inline">•</span>
          <span className="hidden sm:inline">Save </span>
          <span className="font-bold">5% OFF</span> your first project with RS Handyman.
        </span>
        <span className="hidden md:inline-flex items-center gap-1 ml-1 underline decoration-white/50 underline-offset-2">
          Claim it <ArrowRight className="h-3.5 w-3.5" />
        </span>
      </a>
    </div>
  );
}
